import React, { useState } from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';

// ==================== EN-TÊTE DE COLONNE REDIMENSIONNABLE ====================
// Tirer la bordure droite de l'en-tête pour étendre / réduire la largeur de la colonne
const ResizableTitle = (props: any) => {
  const { onResize, width, ...restProps } = props;
  if (!onResize) return <th {...restProps} />;

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const th = (e.currentTarget as HTMLElement).parentElement;
    const startX = e.clientX;
    const startWidth = typeof width === 'number' ? width : (th ? th.offsetWidth : 100);
    const onMouseMove = (ev: MouseEvent) => onResize(Math.max(50, startWidth + ev.clientX - startX));
    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return (
    <th {...restProps} style={{ ...restProps.style, position: 'relative' }}>
      {restProps.children}
      <span
        onMouseDown={onMouseDown}
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'absolute', right: -3, top: 0, bottom: 0, width: 7, cursor: 'col-resize', zIndex: 1, userSelect: 'none' }}
      />
    </th>
  );
};

// ==================== TABLE AVEC COLONNES REDIMENSIONNABLES ====================
// Remplace le Table antd : mêmes props, ajoute uniquement le redimensionnement des colonnes
function TableResizable<T extends object = any>(props: TableProps<T>) {
  const { columns, components, ...rest } = props;
  const [colWidths, setColWidths] = useState<{ [key: string]: number }>({});

  const cols: any = (columns || []).map((col: any, i: number) => {
    const key = String(col.key ?? col.dataIndex ?? i);
    const width = colWidths[key] ?? col.width;
    return {
      ...col,
      width,
      onHeaderCell: (c: any) => ({
        ...(typeof col.onHeaderCell === 'function' ? col.onHeaderCell(c) : {}),
        width,
        onResize: (w: number) => setColWidths((prev) => ({ ...prev, [key]: w })),
      }),
    };
  });

  return (
    <Table<T>
      {...rest}
      columns={columns ? cols : undefined}
      components={{
        ...components,
        header: { ...(components as any)?.header, cell: ResizableTitle },
      }}
    />
  );
}

export default TableResizable;
